export default __webpack_public_path__ + "static/media/field-time.56d19809.svg";